module.exports = __webpack_public_path__ + "img/Pazarama.0917723d.png";